/**
 * @generated SignedSource<<bc1ba5e5cd9d09922e2cf7b09f68b979>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type onboardingOneDeliveryGateQuery$variables = Record<PropertyKey, never>;
export type onboardingOneDeliveryGateQuery$data = {
  readonly onedeliveryProfile: {
    readonly onboardedAt: any | null | undefined;
  } | null | undefined;
};
export type onboardingOneDeliveryGateQuery = {
  response: onboardingOneDeliveryGateQuery$data;
  variables: onboardingOneDeliveryGateQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "OnedeliveryProfile",
    "kind": "LinkedField",
    "name": "onedeliveryProfile",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "onboardedAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "onboardingOneDeliveryGateQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "onboardingOneDeliveryGateQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "cacheID": "7245de111999f28e7fd53f87195165a2",
    "id": null,
    "metadata": {},
    "name": "onboardingOneDeliveryGateQuery",
    "operationKind": "query",
    "text": "query onboardingOneDeliveryGateQuery {\n  onedeliveryProfile {\n    onboardedAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "019d4d94beb6dc4010a9b120b8628e06";

export default node;
